import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import useRequest from "../../Hooks/useRequest";
import {
  getStepOrderBook,
  ORDER_BOOK_POLL_INTERVAL_MS,
} from "../../Requests/stepRequests";
import OrderBookTable from "../../Tables/Manual/OrderBookTable";
import StepOrderBookInfo from "../Step/StepOrderBookInfo";
import { onManualOrderFormValuesChange } from "../../Features/Manual/manualSlice";
import useLiveOrderBooks from "../../Hooks/useLiveOrderBooks";

const OrderBook = () => {
  const dispatch = useAppDispatch();
  const instrumentId = useAppSelector(
    (store) => store.manual.addOrderFormValues?.instrumentId
  );
  const instrumentType = useAppSelector(
    (store) => store.manual.addOrderFormValues?.instrumentType
  );

  const orderBookRequest = useRequest(
    () => getStepOrderBook(instrumentId || undefined, instrumentType),
    (e) => {}
  );
  const liveOrderBooks = useLiveOrderBooks({
    enabled: true,
    instrumentIds: [instrumentId],
  });

  useEffect(() => {
    if (!instrumentId) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, ORDER_BOOK_POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [instrumentId]);

  return (
    <div className="flex flex-row justify-start items-end gap-3">
      <OrderBookTable
        tableInfo={liveOrderBooks.resolveOrderBook(orderBookRequest?.response?.fullOrderBook, instrumentId || undefined)}
      />
      <StepOrderBookInfo
        fundInfo={orderBookRequest?.response?.fundInfo}
        instrumentStatistic={orderBookRequest?.response?.instrumentStatistic}
        onPriceClick={(price) => {
          if (!price) return;
          dispatch(
            onManualOrderFormValuesChange({
              name: "fromPrice",
              value: price,
              name2: "toPrice",
              value2: price,
            })
          );
        }}
      />
    </div>
  );
};

export default OrderBook;
